module.exports = __webpack_public_path__ + "img/basic_lotion_202308.9649e3a0.jpg";